import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

import ListingCard from "@/components/ListingCard";
import { browseApi } from "@/api/browse";
import { logger } from "@/utils/logger";

const Search = () => {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchResults();
  }, [q]);

  const fetchResults = async () => {
    setLoading(true);
    try {
      const data = await browseApi.search({ q });
      setListings(data.listings);
      setTotal(data.total);
    } catch (error) {
      logger.error("Search failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-24 pb-16 px-6 md:px-12 min-h-screen bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-2">Search Results</p>
          <h1 className="text-4xl text-[#EDEDED] mb-2">&quot;{q}&quot;</h1>
          <p className="text-[#A1A1AA]">{total} results found</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" />
          </div>
        ) : listings.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#A1A1AA] text-lg mb-4">No listings found for &quot;{q}&quot;</p>
            <Link to="/" className="btn-secondary text-sm">Back to Home</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {listings.map((listing) => (
              <ListingCard key={listing.listing_id} listing={listing} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
